import { useState, useEffect } from 'react';
import millify from 'millify';
import axios from 'axios';

interface NetworkStatsData {
  totalSnapshots: number | string;
  totalSupply: number | string;
  totalWallets: number | string;
  validatorNodes: number | string;
}

export const useNetworkStats = () => {
  const [data, setData] = useState<NetworkStatsData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      const endpoints = {
        snapshots: 'https://production.dagexplorer-api.constellationnetwork.net/mainnet/stats',
        supply: 'https://l0-lb-mainnet.constellationnetwork.io/dag/total-supply',
        wallets: 'https://l0-lb-mainnet.constellationnetwork.io/dag/wallet-count',
        validators: 'https://l0-lb-mainnet.constellationnetwork.io/cluster/info'
      };

      const [snapshotsRes, supplyRes, walletsRes, validatorsRes] = await Promise.all([
        axios.get(endpoints.snapshots),
        axios.get(endpoints.supply),
        axios.get(endpoints.wallets),
        axios.get(endpoints.validators)
      ]);

      setData({
        totalSnapshots: millify(snapshotsRes?.data?.data?.snapshotsTotal),
        totalSupply: millify(supplyRes?.data?.total / 1e8 ), // data is in 1e8 
        totalWallets: millify(walletsRes?.data?.count),
        validatorNodes: millify(validatorsRes?.data?.length)
      });

    } catch (err) {
      setError('Failed to fetch network statistics');
      console.error('Error fetching network stats:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, loading, error, refetch: fetchData };
};